import axios from 'axios';
import service from './api';
import { Toast } from 'vant';
const root = ''; // process.env.url_api ''

// service循环遍历输出不同的请求方法
const instance = axios.create({
  baseURL: root, // https://api.momentinlet.com示例 http://192.168.1.131
  timeout: 20000,
  headers: {
    Authorization: localStorage.getItem('access_token') || ''
  }
});
const Http = {}; // 包裹请求方法的容器

// 这样不会影响到页面里的toast
let myToast;

// 请求格式/参数的统一
for (const key in service) {
  const api = service[key]; // url method

  // async的作用：避免进入回调地狱
  Http[key] = async function (
    params, // 请求参数 get,delete:url。put,post,patch:data。
    isFormData = false, // 标识是否是form-data请求
    config = {} // 配置参数
  ) {
    const url = api.url;
    let newParams = {};
    // 判断是否需要加载loading框
    if (api.mask) {
      myToast = Toast.loading({
        overlay: false,
        forbidClick: true,
        duration: 0,
        message: '加载中...'
      });
    }

    // content-type是否是form-data的判断
    if (params && isFormData) {
      newParams = new FormData();
      for (const i in params) {
        newParams.append(i, params[i]);
      }
    } else {
      newParams = params;
    }

    // 如果ins为真，则有不同的baseUrl
    if (api.ins) {
      config.baseURL = process.env[api.ins]; // api里的ins要和dev.env,prod.env里的一样才行
    }
    // 不同请求的判断
    let response = {}; // 请求的返回值
    if (
      api.method === 'put' ||
      api.method === 'post' ||
      api.method === 'patch'
    ) {
      try {
        let newUrl = url
        if (url.indexOf('/logistics/notice/readInfo') > -1) {
          newUrl = `${url}/${newParams}`
        }
        response = await instance[api.method](newUrl, newParams, config);
      } catch (err) {
        response = err;
      }
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = newParams; // 从url上传参。如果要放在data里，就在config里设个data。
      try {
        response = await instance[api.method](url, config);
      } catch (err) {
        response = err;
      }
    }
    return response; // 返回响应值
  };
}

// 拦截器的添加
// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 发起请求前做些什么
    if (
      localStorage.getItem('access_token') &&
      localStorage.getItem('access_token') !== 'undefined'
    ) {
      config.headers.Authorization =
        localStorage.getItem('access_token') || '';
    } else {
      config.headers.Authorization = '';
    }
    return config;
  },
  () => {
    // 请求错误
    Toast.loading({
      overlay: false,
      forbidClick: true,
      message: '请求错误，请稍后重试~'
    });
  }
);
// 响应拦截器
instance.interceptors.response.use(
  res => {
    // 请求成功
    if (myToast) {
      myToast.clear();
    }
    if (res.data && String(res.data.code) === '401') {
      const uri = location.href;

      if (uri.indexOf('#') > -1) {
        // 从微信通知消息跳转的 不需要拦截 直接进入页面登录、查询
        const isUserName = uri.indexOf('username') > -1;
        const isPhone = uri.indexOf('phone') > -1;
        const isWaitSignList = uri.indexOf('waitSignList') > -1;
        const isSignEdit = uri.indexOf('signEdit') > -1;
        const isSignedPage = uri.indexOf('signedPage') > -1;

        if ((isWaitSignList || isSignEdit || isSignedPage) && isUserName && isPhone) return
        window.location.replace(uri.split('#')[0] + '#/login');
        localStorage.clear();
        sessionStorage.clear();
      }
    } else if (res.data && res.data.code == 500) {
      console.log('500 异常......');
      console.log(JSON.stringify(res.data));
      console.log('500 异常......');
      setTimeout(() => {
        Toast((res.data.msg || '服务器异常'));
      }, 1000);
      return Promise.reject(res.data);
    }
    return res.data;
  },
  () => {
    // 请求失败
    Toast.loading({
      overlay: false,
      forbidClick: true,
      message: '请求错误，请稍后重试~'
    });
  }
);

export default Http;



// WEBPACK FOOTER //
// ./src/api/http.js